// language=GraphQL
export const ALL_PAGES_QUERY = `query Query($withSeoSettings: Boolean = false, $withSeoSettingsOgImage: Boolean = false, $withContentBlockAssignments: Boolean = false, $withContentBlockAssignmentsBlock: Boolean = false, $withContentBlockAssignmentsBlockDeep: Boolean = false) {
  pages: cmsPages {
    id
    name
    onlineStatus
    seoSettings @include(if: $withSeoSettings) {
      id
      urlSlug
      metaTitle
      metaDescription
      ogTitle
      ogDescription
      ogImage @include(if: $withSeoSettingsOgImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    contentBlockAssignments @include(if: $withContentBlockAssignments) {
      id
      type
      block @include(if: $withContentBlockAssignmentsBlock) {
        __typename
        ... on CmsTextBlock {
          id
          text

        }
        ... on CmsTextWithImageBlock {
          id
          title
          subtitle
          text
          imagePosition
          image @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          imageFixedAspectRatio
          gallery @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
          }
          link @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            label
            targetBlank
            type
            url
          }

        }
        ... on CmsPageHeaderBlock {
          id
          title
          text
          image @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }

        }
        ... on CmsWysiwygBlock {
          id
          html

        }
        ... on CmsHeadingBlock {
          id
          importance
          heading
          addon
          decoration

        }
        ... on CmsTextWithIconBlock {
          id
          title
          text
          image @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          imagePosition

        }
        ... on CmsAccordionBlock {
          id
          items @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            title
            content
          }

        }
        ... on CmsGridBlock {
          id
          columns @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
          }

        }
        ... on CmsImageBlock {
          id
          image @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          text
          fluid

        }
        ... on CmsEmployeesBlock {
          id
          employees @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }

        }
        ... on CmsContactBannerBlock {
          id
          employee @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          email
          phonePrefix
          phone
          phone2Prefix
          phone2

        }
        ... on CmsNewsletterRegisterBlock {
          id
          fluid

        }
        ... on CmsIssuuCatalogBlock {
          id
          publicationCode
          accountName

        }
        ... on CmsFormBlock {
          id
          formName

        }
        ... on CmsHeaderSliderBlock {
          id
          travels @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            introVideoUrl
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
          slides @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            title
            text
          }

        }
        ... on CmsBestsellerSliderBlock {
          id
          fluid

        }
        ... on CmsFilterLeadBlock {
          id
          layout

        }
        ... on CmsTravelTypesBlock {
          id
          layout

        }
        ... on CmsPrefilteredTravelsBlock {
          id
          destinations @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }
          travelTypes @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            description
          }
          maxResults

        }
        ... on CmsDividerBlock {
          id
          fluid

        }
        ... on CmsTravelSelectionBlock {
          id
          travels @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            introVideoUrl
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }

        }
        ... on CmsIframeBlock {
          id
          url
          minHeight

        }
        ... on CmsSliderBlock {
          id
          fluid
          gallery @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
          }
          size
          showDots
          showArrows
          showLightbox
          autoplay

        }
        ... on CmsDestinationsBlock {
          id
          destinations @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }

        }
        ... on CmsTravelGuidesBlock {
          id
          travelGuides @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            firstName
            lastName
            description
          }

        }
        ... on CmsBusfinderBlock {
          id
          title

        }
        ... on CmsBackgroundBlock {
          id
          backgroundVariant
          contentBlockAssignments @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            type
          }

        }
        ... on CmsButtonBlock {
          id
          variant
          size
          position
          link @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            label
            targetBlank
            type
            url
          }

        }
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_PAGE_QUERY = `query Query($id: ID!, $withSeoSettings: Boolean = false, $withSeoSettingsOgImage: Boolean = false, $withContentBlockAssignments: Boolean = false, $withContentBlockAssignmentsBlock: Boolean = false, $withContentBlockAssignmentsBlockDeep: Boolean = false) {
  page: cmsPage(id: $id) {
    id
    name
    onlineStatus
    seoSettings @include(if: $withSeoSettings) {
      id
      urlSlug
      metaTitle
      metaDescription
      ogTitle
      ogDescription
      ogImage @include(if: $withSeoSettingsOgImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    contentBlockAssignments @include(if: $withContentBlockAssignments) {
      id
      type
      block @include(if: $withContentBlockAssignmentsBlock) {
        __typename
        ... on CmsTextBlock {
          id
          text

        }
        ... on CmsTextWithImageBlock {
          id
          title
          subtitle
          text
          imagePosition
          image @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          imageFixedAspectRatio
          gallery @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
          }
          link @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            label
            targetBlank
            type
            url
          }

        }
        ... on CmsPageHeaderBlock {
          id
          title
          text
          image @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }

        }
        ... on CmsWysiwygBlock {
          id
          html

        }
        ... on CmsHeadingBlock {
          id
          importance
          heading
          addon
          decoration

        }
        ... on CmsTextWithIconBlock {
          id
          title
          text
          image @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          imagePosition

        }
        ... on CmsAccordionBlock {
          id
          items @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            title
            content
          }

        }
        ... on CmsGridBlock {
          id
          columns @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
          }

        }
        ... on CmsImageBlock {
          id
          image @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          text
          fluid

        }
        ... on CmsEmployeesBlock {
          id
          employees @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }

        }
        ... on CmsContactBannerBlock {
          id
          employee @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          email
          phonePrefix
          phone
          phone2Prefix
          phone2

        }
        ... on CmsNewsletterRegisterBlock {
          id
          fluid

        }
        ... on CmsIssuuCatalogBlock {
          id
          publicationCode
          accountName

        }
        ... on CmsFormBlock {
          id
          formName

        }
        ... on CmsHeaderSliderBlock {
          id
          travels @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            introVideoUrl
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
          slides @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            title
            text
          }

        }
        ... on CmsBestsellerSliderBlock {
          id
          fluid

        }
        ... on CmsFilterLeadBlock {
          id
          layout

        }
        ... on CmsTravelTypesBlock {
          id
          layout

        }
        ... on CmsPrefilteredTravelsBlock {
          id
          destinations @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }
          travelTypes @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            description
          }
          maxResults

        }
        ... on CmsDividerBlock {
          id
          fluid

        }
        ... on CmsTravelSelectionBlock {
          id
          travels @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            introVideoUrl
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }

        }
        ... on CmsIframeBlock {
          id
          url
          minHeight

        }
        ... on CmsSliderBlock {
          id
          fluid
          gallery @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
          }
          size
          showDots
          showArrows
          showLightbox
          autoplay

        }
        ... on CmsDestinationsBlock {
          id
          destinations @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }

        }
        ... on CmsTravelGuidesBlock {
          id
          travelGuides @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            firstName
            lastName
            description
          }

        }
        ... on CmsBusfinderBlock {
          id
          title

        }
        ... on CmsBackgroundBlock {
          id
          backgroundVariant
          contentBlockAssignments @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            type
          }

        }
        ... on CmsButtonBlock {
          id
          variant
          size
          position
          link @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            label
            targetBlank
            type
            url
          }

        }
      }
    }
  }
}`

// language=GraphQL
export const CREATE_PAGE_MUTATION = `
  mutation Mutation($input: CreateCmsPageInput, $withSeoSettings: Boolean = false, $withSeoSettingsOgImage: Boolean = false, $withContentBlockAssignments: Boolean = false, $withContentBlockAssignmentsBlock: Boolean = false, $withContentBlockAssignmentsBlockDeep: Boolean = false) {
    page: createCmsPage(input: $input) {
      id
      name
      onlineStatus
      seoSettings @include(if: $withSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      contentBlockAssignments @include(if: $withContentBlockAssignments) {
        id
        type
        block @include(if: $withContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            image @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            imageFixedAspectRatio
            gallery @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
            }
            link @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              label
              targetBlank
              type
              url
            }

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text
            image @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            image @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            imagePosition

          }
          ... on CmsAccordionBlock {
            id
            items @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              title
              content
            }

          }
          ... on CmsGridBlock {
            id
            columns @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
            }

          }
          ... on CmsImageBlock {
            id
            image @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id
            employees @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              firstName
              lastName
              jobTitle
              description
              email
              phone
            }

          }
          ... on CmsContactBannerBlock {
            id
            employee @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              firstName
              lastName
              jobTitle
              description
              email
              phone
            }
            email
            phonePrefix
            phone
            phone2Prefix
            phone2

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id
            travels @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              isBestseller
              startDate
              endDate
              executionStatus
              title
              description
              introVideoUrl
              includedServices
              excludedServices
              pricingTable
              priceCalculationInfo
              programType
              programText
              minPrice
              minPriceManualOverride
              currency
            }
            slides @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              title
              text
            }

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            destinations @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              entryRequirements
              medicalInformation
              language
              timeShift
              climate
              currency
            }
            travelTypes @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              description
            }
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id
            travels @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              isBestseller
              startDate
              endDate
              executionStatus
              title
              description
              introVideoUrl
              includedServices
              excludedServices
              pricingTable
              priceCalculationInfo
              programType
              programText
              minPrice
              minPriceManualOverride
              currency
            }

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            gallery @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
            }
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id
            destinations @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              entryRequirements
              medicalInformation
              language
              timeShift
              climate
              currency
            }

          }
          ... on CmsTravelGuidesBlock {
            id
            travelGuides @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              firstName
              lastName
              description
            }

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant
            contentBlockAssignments @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              type
            }

          }
          ... on CmsButtonBlock {
            id
            variant
            size
            position
            link @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              label
              targetBlank
              type
              url
            }

          }
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_PAGE_MUTATION = `
  mutation Mutation($input: UpdateCmsPageInput, $withSeoSettings: Boolean = false, $withSeoSettingsOgImage: Boolean = false, $withContentBlockAssignments: Boolean = false, $withContentBlockAssignmentsBlock: Boolean = false, $withContentBlockAssignmentsBlockDeep: Boolean = false) {
    page: updateCmsPage(input: $input) {
      id
      name
      onlineStatus
      seoSettings @include(if: $withSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      contentBlockAssignments @include(if: $withContentBlockAssignments) {
        id
        type
        block @include(if: $withContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            image @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            imageFixedAspectRatio
            gallery @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
            }
            link @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              label
              targetBlank
              type
              url
            }

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text
            image @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            image @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            imagePosition

          }
          ... on CmsAccordionBlock {
            id
            items @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              title
              content
            }

          }
          ... on CmsGridBlock {
            id
            columns @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
            }

          }
          ... on CmsImageBlock {
            id
            image @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id
            employees @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              firstName
              lastName
              jobTitle
              description
              email
              phone
            }

          }
          ... on CmsContactBannerBlock {
            id
            employee @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              firstName
              lastName
              jobTitle
              description
              email
              phone
            }
            email
            phonePrefix
            phone
            phone2Prefix
            phone2

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id
            travels @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              isBestseller
              startDate
              endDate
              executionStatus
              title
              description
              introVideoUrl
              includedServices
              excludedServices
              pricingTable
              priceCalculationInfo
              programType
              programText
              minPrice
              minPriceManualOverride
              currency
            }
            slides @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              title
              text
            }

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            destinations @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              entryRequirements
              medicalInformation
              language
              timeShift
              climate
              currency
            }
            travelTypes @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              description
            }
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id
            travels @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              isBestseller
              startDate
              endDate
              executionStatus
              title
              description
              introVideoUrl
              includedServices
              excludedServices
              pricingTable
              priceCalculationInfo
              programType
              programText
              minPrice
              minPriceManualOverride
              currency
            }

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            gallery @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
            }
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id
            destinations @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              entryRequirements
              medicalInformation
              language
              timeShift
              climate
              currency
            }

          }
          ... on CmsTravelGuidesBlock {
            id
            travelGuides @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              firstName
              lastName
              description
            }

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant
            contentBlockAssignments @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              type
            }

          }
          ... on CmsButtonBlock {
            id
            variant
            size
            position
            link @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              label
              targetBlank
              type
              url
            }

          }
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_PAGE_MUTATION = `
  mutation Mutation($input: DeleteCmsPageInput) {
    deleteCmsPage(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_PAGE_MUTATION = `
  mutation Mutation($input: DeleteCmsPageInput) {
    forceDeleteCmsPage(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_PAGE_CONTENT_BLOCK_ASSIGNMENTS_MUTATION = `
  mutation Mutation($input: addCmsPageContentBlockAssignmentsInput) {
    addCmsPageContentBlockAssignments(input: $input) {
      id
      contentBlockAssignmentIds
    }
  }`

// language=GraphQL
export const REMOVE_PAGE_CONTENT_BLOCK_ASSIGNMENTS_MUTATION = `
  mutation Mutation($input: removeCmsPageContentBlockAssignmentsInput) {
    removeCmsPageContentBlockAssignments(input: $input) {
      id
      contentBlockAssignmentIds
    }
  }`

// language=GraphQL
export const CREATE_PAGE_CONTENT_BLOCK_ASSIGNMENTS_MUTATION = `
  mutation Mutation($input: createCmsPageContentBlockAssignmentsInput) {
    createCmsPageContentBlockAssignments(input: $input) {
      id
      contentBlockAssignmentIds
    }
  }`

// language=GraphQL
export const DELETE_PAGE_CONTENT_BLOCK_ASSIGNMENTS_MUTATION = `
  mutation Mutation($input: deleteCmsPageContentBlockAssignmentsInput) {
    deleteCmsPageContentBlockAssignments(input: $input) {
      id
      contentBlockAssignmentIds
    }
  }`

// language=GraphQL
export const UPDATE_PAGE_CONTENT_BLOCK_ASSIGNMENTS_ORDER_MUTATION = `
  mutation Mutation($input: updateCmsPageContentBlockAssignmentsOrderInput) {
    updateCmsPageContentBlockAssignmentsOrder(input: $input) {
      id
      contentBlockAssignmentIds
    }
  }`

// language=GraphQL
export const PAGES_DEPENDENTS_QUERY = `query Query($id: ID!, $withTenantCms: Boolean = false, $withRedirects: Boolean = false, $withCmsConfigs: Boolean = false, $withLinks: Boolean = false, $withCmsCategories: Boolean = false) {
  groupedDependents: cmsPageDependents(id: $id) {
    tenantCms @include(if: $withTenantCms) {
      id
    }
    redirects @include(if: $withRedirects) {
      id
      fromType
      fromUrl
      toType
      toUrl
    }
    cmsConfigs @include(if: $withCmsConfigs) {
      id
    }
    links @include(if: $withLinks) {
      id
      label
      targetBlank
      type
      url
    }
    cmsCategories @include(if: $withCmsCategories) {
      id
      name
    }
  }
}`
